/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ButtonIconMarker from 'DesignSystem/ButtonIconMarker/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconPaid from 'DesignSystem/Svgs/TysiaIconPaid/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Menu/FinancialAction/Content",
  isSelected
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<fromFlow.When is={!isMedia.laptop}>
<ButtonIconMarker
  viewPath={`${viewPath}/ButtonIconMarker`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Content/Financial'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../Content/Financial'))}
>
{childProps => (
<TysiaIconPaid
{...childProps}
  viewPath={`${viewPath}/TysiaIconPaid`}
 width={25}
 height={25}
 fill={childProps.isSelected ? dtColorsBrandBase : dtColorsNeutral500}
/>
)}
</ButtonIconMarker>
</fromFlow.When>
<fromFlow.When is={isMedia.laptop}>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 block={true}
 justifyContent="flex-start"
 marginTop={dtSpaceXs}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Content/Financial'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../Content/Financial'))}
 selected={flow.has(fromFlow.normalizePath(viewPath, '../../../Content/Financial'))}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconPaid
{...childProps}
  viewPath={`${viewPath}/TysiaIconPaid`}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={dtSpaceXxs}
 text="Financials"
/>
</React.Fragment>
)}
</TysiaButton>
</fromFlow.When>
{children}
</React.Fragment>)
}